import React from 'react';
import {feedbackSentence} from './lib/inequality';
import {answerConfirm} from '../money/lib/money';

export default class Feedback extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    if(this.props.visible){
      if (this.props.showInitialFeedback) {
        return (
          <div className="inequality-feedback">
            <p className="inequality-feedback__sentence--initial">
              Click &#60;, =, or &#62; before checking your answer.
            </p>
          </div>
        );  
      } else {
        return (
          <div className="inequality-feedback">
            <span className={this.props.isAnswerCorrect ? 
                            'inequality-feedback__correct' : 'inequality-feedback__incorrect'}>
              {answerConfirm(this.props.isAnswerCorrect)}
            </span>
            <p className="inequality-feedback__sentence">{feedbackSentence(this.props.leftNumber, 
                              this.props.rightNumber, 
                              this.props.equalitySymbol)}</p>
          </div>
        );  
      }
    }
    else {
      return (
        <div className="inequality-feedback"></div>
      );
    }
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/inequality/feedback.js
 **/